<template>
  <div class="protocol-page">
    <div class="header">
      <h1>用户使用协议</h1>
    </div>
    
    <div class="container">
      <div class="content-wrapper">
        <div class="greeting">
          <h2>尊敬的用户：</h2>
        </div>
        
        <div class="introduction">
          欢迎您使用"恰恰好"应用程序（以下简称"本应用"）。在您开始使用本应用之前，请您仔细阅读并理解以下用户协议（以下简称"本协议"）。本协议是您与本应用开发者（以下简称"我们"或"开发者"）之间就您使用本应用所达成的法律协议。一旦您下载、安装、注册或以任何方式使用本应用，即表示您已阅读、理解并同意接受本协议的所有条款和条件。如果您不同意本协议的任何内容，请不要使用本应用。
        </div>

        <div v-for="(section, index) in sections" :key="index" class="section">
          <h3 class="section-title">{{ section.title }}</h3>
          <div class="section-content">{{ section.content }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'UserProtocol',
  data() {
    return {
        sections: [
    {
      title: "1 接受条款",
      content: "恰恰好APP（以下统称为\"本应用\"）是为用户提供的饮食记录工具软件。您使用本应用产品或服务的行为（包括下载、安装、启动、浏览、注册、登录、使用、付费购买等行为），表示已经充分理解本协议，并同意接受本协议各项条款的约束，成为本应用用户（以下简称\"用户\"）。如果您不愿意接受本协议相应条款的，请您不要使用本应用产品或服务。如您在本协议更新后继续使用本应用产品或服务，即表示您同意接受更新后的协议约束。如您不接受更新后的协议，请您不要使用本应用产品或服务，或仅在技术允许的范围内，使用本应用产品或服务的未更新版本。"
    },
    {
      title: "2 服务说明",
      content: "本应用APP目前向用户提供拍摄热量识别、食物记录、运动记录、体重记录、减肥计划等功能，并支持在记录时拍摄、上传图片的服务。此外为丰富您的使用体验，还会在上述服务的基础上为您提供，例如，饮食推荐、减肥报告等辅助功能。除非本使用协议另有其它明示规定，增加或强化目前本服务的任何新功能，包括所推出的新产品，均受到本使用协议之规范。您了解并同意，本服务仅依其当前所呈现的状况提供，对于任何用户信息或个人化设定之时效、删除、传递错误、未予储存或其它任何问题，本应用均不承担任何责任。本应用保留不经事先通知为维修保养、升级或其它目的暂停本服务任何部分的权利,并无需承担任何责任。"
    },
    {
      title: "3 遵守法律",
      content: "您同意遵守中华人民共和国相关法律法规的所有规定，并对以任何方式使用您的密码和您的帐号使用本服务的任何行为及其结果承担全部责任。如您的行为违反国家法律和法规的任何规定，有可能构成犯罪的，将被追究刑事责任，并由您承担全部法律责任。 同时如果本应用有理由认为您的任何行为，包括但不限于您的任何言论和其它行为违反或可能违反国家法律和法规的任何规定，本应用可在任何时候不经任何事先通知终止向您提供服务。"
    },
    {
      title: "4 您的注册义务",
      content: "为了能使用本服务全部功能，您理解并同意以下事项：从官方渠道成功下载本应用APP后，可以选择合法的手机号码作为账号，并通过短信验证码进行注册。或通过第三方平台账号登录授权，并确保今后更新的授权账号等资料的有效性和合法性。若您提供任何违法、不道德或本应用认为不适合在本应用上展示的资料；或者本应用有理由怀疑你的资料属于程序或恶意操作，本应用有权暂停或终止您的帐号，并拒绝您于现在和未来使用本服务之全部或任何部分。 本应用无须对任何用户的任何登记资料承担任何责任，包括但不限于鉴别、核实任何登记资料的真实性、正确性、完整性、适用性及是否为最新资料的责任。"
    },
    {
      title: "5 用户帐号及安全",
      content: "完成本服务的注册程序并成功注册之后，您可使用您授权账号，登录到您在本应用的帐号（下称\"帐号\"）。保护您的帐号安全，是您的责任。您应对所有使用您的验证码及帐号的活动负完全的责任。您同意：\n 1)您的本应用帐号遭到未获授权的使用，或者发生其它任何安全问题时，您将立即通知本应用；\n2)如果您未保管好自己的授权帐号和验证码，因此而产生的任何损失或损害，本应用无法也不承担任何责任；\n3)每个用户都要对其帐号中的所有行为和事件负全责。如果您未保管好自己的帐号和验证码而对您、本应用或第三方造成的损害，您将负全部责任。"
    },
    {
      title: "6 本应用隐私权政策",
      content: "您提供的登记资料及本应用保留的有关您的若干其它资料将受到中国有关隐私的法律和本公司《隐私声明》之规范。"
    },
    {
      title: "7 提供者之责任",
      content: "根据有关法律法规，本应用在此郑重提请您注意，任何经由本服务而发布、上传的文字、资讯、资料、音乐、视频、照片、图形、视讯、信息或其它资料（以下简称\"内容\"），无论系公开还是私下传送，均由内容提供者承担责任。本应用仅为用户提\n供内容存储空间，无法控制经由本服务传送之内容，因此不保证内容的正确性、完整性或品质。在任何情况下，本应用均不为任何内容负责，但本应用有权依法停止传输任何前述内容并采取相应行动，包括但不限于暂停用户使用本服务的全部或部分，保存有关记录，并向有关机关报告。"
    },
    {
      title: "8 用户行为",
      content: "用户同意将不会利用本服务进行任何违法或不正当的活动，包括但不限于下列行为∶\n1)发布或以其它方式传送含有下列内容之一的信息：\n* 反对宪法所确定的基本原则的；\n* 危害国家安全，泄露国家秘密，颠覆国家政权，破坏国家统一的；\n* 损害国家荣誉和利益的；\n* 煽动民族仇恨、民族歧视、破坏民族团结的；\n* 破坏国家宗教政策，宣扬邪教和封建迷信的；\n* 散布谣言，扰乱社会秩序，破坏社会稳定的；\n* 散布淫秽、色情、赌博、暴力、凶杀、恐怖或者教唆犯罪的；\n* 侮辱或者诽谤他人，侵害他人合法权利的；\n* 含有虚假、诈骗、有害、胁迫、侵害他人隐私、骚扰、侵害、中伤、粗俗、猥亵、或其它道德上令人反感的内容；\n* 含有中国法律、法规、规章、条例以及任何具有法律效力之规范所限制或禁止的其它内容的；\n* 含有本应用认为不适合在本应用展示的内容；\n2)以任何方式危害他人的合法权益；\n3)冒充其他任何人或机构，或以虚伪不实的方式陈述或谎称与任何人或机构有关；\n4)将依据任何法律或合约或法定关系（例如由于雇佣关系和依据保密合约所得知或揭露之内部资料、专属及机密资料）知悉但无权传送之任何内容加以发布、发送电子邮件或以其它方式传送；\n5)将侵害他人著作权、专利权、商标权、商业秘密、或其它专属权利（以下简称\"专属权利\"）之内容加以发布或以其它方式传送；\n6)将任何广告信函、促销资料、\"垃圾邮件\"、\"滥发信件\"、\"连锁信件\"、\"直销\"或其它任何形式的劝诱资料加以发布、发送或以其它方式传送；\n7)将设计目的在于干扰、破坏或限制任何计算机软件、硬件或通讯设备功能之计算机病毒（包括但不限于木马程序（trojan horses）、蠕虫（worms）、定时炸弹、删除蝇（cancelbots）（以下简称\"病毒\"）或其它计算机代码、档案和程序之任何资料，加以发布、发送或以其它方式传送；\n8)干扰或破坏本服务或与本服务相连线之服务器和网络，或违反任何关于本服务连线网络之规定、程序、政策或规范；\n9)跟踪、人肉搜索或以其它方式骚扰他人；\n10)故意或非故意地违反任何适用的当地、国家法律，以及任何具有法律效力的规则；\n11)未经合法授权而截获、篡改、收集、储存或删除他人个人信息、站内邮件或其它数据资料，或将获知的此类资料用于任何非法或不正当目的。\n12)本应用不会容忍任何令人反感的内容和用户，并通过智能识别、人工审核等方式过滤不良内容。并对发布违规内容进行删除、对发布者进行账号管制。\n13)用户可以对公开发布的信息进行监督，在对应功能页面中可以对发现的违规内容进行举报，任何举报都会在24小时内进行处理。\n14)您可以通过客服邮箱：dongsen001@gmail.com 与我们取得联系，反馈您在使用本应用过程中发现的问题以及您对产品的看法和建议。\n您已认可本应用未对用户的使用行为进行全面控制，您使用任何内容时，包括依赖前述内容之正确性、完整性或实用性时，您同意将自行加以判断并承担所有风险，而不依赖于本应用。但本应用依其自行之考虑，拒绝和删除可经由本服务提供之违反本条款的或其它引起本应用反感的任何内容。您了解并同意，本应用依据法律法规的要求，或基于诚信为了以下目的或在合理必要范围内，认定必须将内容加以保存或揭露时，得加以保存或揭露：\na)遵守法律程序；\nb)执行本使用协议；\nc)回应任何第三人提出的权利主张；\nd)保护本应用、其用户及公众之权利、财产或个人安全；\ne)其它本应用认为有必要的情况。"
    },
    {
        title: "9 国际使用之特别警告",
        content: "您已了解国际互联网的无国界性，同意遵守当地所有关于网上行为及内容之法律法规。您特别同意遵守有关从中国或您所在国家或地区输出信息之传输的所有适用法律法规。"
    },
    {
        title: "10 在本应用发布的公开信息",
        content: "1)在本使用协议中，\"本服务公开使用区域\"系指一般公众可以使用的区域；\n2)用户在本应用上传的内容，用户应保证其为著作权人或已取得合法授权，并且该内容不会侵犯任何第三方的合法权益，用户同意授予本应用所有上述内容在全球范围内的免费、不可撤销的、永久的、可再许可独家使用权许可，据该许可本应用将有权以复制、广播、汇编、网络传播及其他不为我法律所禁止的方式使用前述内容。"
    },
    {
        title: "11 赔偿",
        content: "由于您通过本服务提供、发布或传送之内容、您与本服务连线、您违反本使用协议、或您侵害他人任何权利因而衍生或导致任何第三人提出任何索赔或请求，包括合理的律师费，您同意赔偿本应用及其子公司、关联企业、高级职员、代理人、品牌共有人或其它合作伙伴及员工，并使其免受损害，并承担由此引发的全部法律责任。"
    },
    {
        title: "12 关于使用及储存之一般措施",
        content: "您同意不对本服务任何部分或本服务所使用或获得的内容，进行复制、拷贝、出售、转售或用于任何其它商业目的。"
    },
    {
        title: "13 服务之修改",
        content: "本应用有权于任何时间暂时或永久修改或终止本服务（或其任何部分），且无论通知与否。您同意对于本服务所作的任何修改、暂停或终止，本应用对您和任何第三人均无需承担任何责任。"
    },
    {
        title: "14 终止服务",
        content: "您同意本应用基于其自行之考虑，因任何理由，包含但不限于缺乏使用，或本应用认为您已经违反本使用协议的文字及精神，终止您的帐号或本服务之使用（或服务之任何部分），并将您在本服务内任何内容加以移除并删除。您同意依本使用协议任何规定提供之本服务，无需进行事先通知即可中断或终止，您承认并同意，本应用可立即关闭或删除您的帐号及您帐号中所有相关信息及文件，及/或禁止继续使用前述文件或本服务。此外，您同意若本服务之使用被中断或终止或您的帐号及相关信息和文件被关闭或删除，本应用对您或任何第三人均不承担任何责任。"
    },
    {
        title: "15 与广告商及其他第三方进行交易",
        content: "您通过本网站与广告商及其他第三方进行任何形式的通讯或商业往来，或参与促销活动，包含相关商品或服务之付款及交付，以及达成的其它任何相关条款、条件、保证或声明，完全为您与广告商及其他第三方之间之行为。您因前述任何交易或前述广告商及其他第三方而遭受的任何性质的损失或损害，本应用对此不负任何法律责任。"
    },
    {
        title: "16 本应用之专属权利",
        content: "您了解并同意，本服务及本服务所使用之相关软件（以下简称\"软件\"）含有受到相关知识产权及其它法律保护之专有保密资料。您也了解并同意，经由本服务或广告商向您呈现之赞助广告或信息所包含之内容，亦受到著作权、商标权、服务商标、专利权或其它专属权利之法律保护。未经本应用或广告商明示授权，您不得修改、出租、出借、出售、散布本服务或软件之任何部份或全部，或据以制作衍生著作，或使用擅自修改后的软件，包括但不限于为了未经授权而使用本服务之目的。本应用仅授予您个人、不可移转及非专属之使用权，使您得于单机计算机使用其软件之目的码，但您不得（并不得允许任何第三人）复制、修改、创作衍生著作、进行还原工程、反向组译，或以其它方式发现原始码，或出售、转让、再授权或提供软件设定担保，或以其它方式移转软件之任何权利。您同意将通过由本应用所提供的界面而非任何其它途径使用本服务。"
    },
    {
        title: "17 担保与保证",
        content: "您明确了解并同意：\n1)本使用协议的任何规定不会免除本应用对造成您人身伤害的、或因故意或重大过失造成您财产损失的任何责任；\n2)您使用本服务之风险由您个人负担。本服务系依\"现状\"及\"现有\"基础提供。本应用对本服务不提供任何明示或默示的担保或保证，包含但不限于商业适售性、特定目的之适用性及未侵害他人权利等担保或保证；\n3)本应用不保证以下事项：\n* 本服务将符合您的要求；\n* 本服务将不受干扰、及时提供、安全可靠或不会出错；\n* 使用本服务取得之结果正确可靠；\n* 您经由本服务购买或取得之任何产品、服务、资讯或其它信息将符合您的期望；\n4）是否使用本服务下载或取得任何资料应由您自行考虑且自负风险，因任何资料之下载而导致的您电脑系统之任何损坏或数据流失等后果，由您自行承担；\n5）您自本应用或经由本服务取得的任何建议或信息，无论是书面或口头形式，除非本使用协议有明确规定，将不构成本使用协议以外之任何保证。"
    },
    {
        title: "18 责任限制",
        content: "您明确了解并同意，基于以下原因而造成的，包括但不限于利润、信誉、应用、数据损失或其它无形损失，本应用不承担任何直接、间接、附带、特别、衍生性或惩罚性赔偿责任：\n1)本服务之使用或无法使用；\n2)为替换从或通过本服务购买或取得之任何商品、数据、信息、服务，收到的讯息，或缔结之交易而发生的成本；\n3)您的传输或数据遭到未获授权的存取或变造；\n4)任何第三方在本服务中所作之声明或行为；\n5)与本服务相关的其它事宜，但本使用协议有明确规定的除外；\n6)第三方以任何方式发布或投递欺诈性信息，或诱导用户受到经济损失，本应用不承担任何责任。"
    },
    {
        title: "19 本应用商标信息",
        content: "本应用App内的所有内容（您上传的由您原创或经第三方合法授权的内容除外）、本应用第三方平台官方账号（包括但不限于微信公众号、微博账号等）发布的所有内容、技术、软件、程序、数据及其他信息（包括但不限于文字、图像、图片、照片、音频、视频、图表、色彩、版面设计、电子文档）和经我们创作、整理或以其他方式（如人工智能）生成内容的所有知识产权（包括但不限于版权、商标权、专利权、商业秘密等）及其他相关权益，完整归属于我们所有；在我们提供本应用产品或服务过程中所依托的软件著作权、专利权、商标权及其他知识产权归我们所有或我们已从第三方权利人处获得合法使用的有效授权。我们享有的所有知识产权和相关权益，不因您的任何使用行为而发生任何的权利转移。请您在任何情况下都不要私自使用、擅自删除、隐匿、掩盖或更改我们的任何商业标识（包括但不限于我们的商标、Logo、\"本应用\"文字、图形及其组合，以及其他标识、徵记、产品和服务名称）、商号、域名、网站名称或其他显著品牌特征、版权声明、权利声明及其他标识（包括但不限于深度合成标识）（以下统称\"标识\"）。未经我们的事先书面同意，您不得将本条款前述标识以单独或结合任何方式展示、使用或申请注册商标、进行域名注册或版权登记等，也不得向他人明示或暗示您有权展示、使用、或其他有权处理这些标识，亦不得实施任何误使他人认为您与这些标识有关联的其他行为。如由于您违反本协议使用我们的上述标识等给我们或他人造成损失的，需要由您承担法律责任。"
    },
    {
        title: "20 用户专属权利",
        content: "本应用尊重他人知识产权，呼吁用户也要同样尊重知识产权。本应用之服务与资料是基于\"现状\"提供，而且本应用明确地表示拒绝对于\"服务\"、\"资料\"或\"产品\"给予任何明示或暗示之保证，包括但不限于，得为商业使用或适合于特定目的之保证。本应用对于因\"服务\"、\"资\"或\"产品\"所生之任何直接、间接、附带的或因此而导致之衍生性损失概不负责。如果您对他人的知识产权造成了侵害，本应用将依国家法律法规的规定，或在适当的情形下，将依其服务条款或其相关规范性规定，删除特定内容或以至终止您对账户的使用。本应用尊重他人的任何权利（包括知识产权），同时也要求我们的使用者也尊重他人之权利。本应用在适当情况下，得自行决定终止侵害或违反他人权利之使用者的帐号。若您认为您的作品的著作权遭到侵害或您的知识产权被侵犯，根据《信息网络传播权保护条例》的规定，您需及时向本应用联系并提供详实的举证材料。或请到中华人民共和国国家版权局下载《要求删除或断开链接侵权网络内容的通知》（下称\"删除通知\"）的示范格式，如果您不明白\"删除通知\"的内容，请登录中华人民共和国国家版权局查看《要求删除或断开链接侵权网络内容的通知》填写说明。"
    },
    {
        title: "21 一般条款",
        content: "1)本使用协议、社区指导原则和免责声明构成您与本应用之全部协议，并规范您对于本服务之使用行为。在您使用相关服务、使用第三方提供的内容或软件时，亦应遵从所适用之附加条款及条件；\n2)本使用协议及您与本应用之关系，均受到中华人民共和国法律管辖。您与本应用就本服务、本使用协议或其它有关事项发生的争议，应首先友好协商解决，协商不成时应提请中国国际经济贸易仲裁委员会仲裁，仲裁裁决是终局性的，对双方均有约束力；\n3)本应用未行使或执行本使用协议任何权利或规定，不构成对前述权利或权利之放弃；\n4)倘本使用协议之任何规定因与中华人民共和国法律抵触而无效，您依然同意应依照法律，努力使该规定所反映之当事人意向具备效力，且本使用协议其它规定仍应具有完整的效力及效果；\n5)本使用协议之标题仅供方便而设，不具任何法律或契约效果；\n6)只要您登录了本应用，就代表您接受任何以上所有协议；\n7)本应用对本使用协议享有最终解释权。"
    }
        ]
    }
  }
}
</script>

<style scoped>
.protocol-page {
  background-color: #f5f5f5;
  min-height: 100vh;
}

.header {
  position: sticky;
  top: 0;
  z-index: 10;
  background-color: white;
  padding: 16px;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
}

.header h1 {
  margin: 0;
  font-size: 18px;
  text-align: center;
  color: #333;
}

.container {
  max-width: 800px;
  margin: 0 auto;
  padding: 16px;
}

.content-wrapper {
  background-color: white;
  border-radius: 8px;
  padding: 24px;
  box-shadow: 0 1px 3px rgba(0,0,0,0.1);
}

.greeting h2 {
  font-size: 18px;
  font-weight: bold;
  margin-bottom: 16px;
}

.introduction {
  font-size: 16px;
  line-height: 1.6;
  margin-bottom: 24px;
  color: #333;
}

.section {
  padding: 16px 0;
}

.section:first-child {
  border-top: none;
  padding-top: 0;
}

.section-title {
  font-size: 18px;
  font-weight: bold;
  margin-bottom: 12px;
  color: #333;
}

.section-content {
  font-size: 16px;
  line-height: 1.6;
  color: #444;
  white-space: pre-line;
}

@media screen and (max-width: 768px) {
  .container {
    padding: 12px;
  }
  
  .content-wrapper {
    padding: 16px;
  }
  
  .section {
    padding: 12px 0;
  }
}
</style> 